<script>
  import { Icon } from "svelte-awesome";
  import { faPhone } from "@fortawesome/free-solid-svg-icons";
</script>

<div class="footer">
  <p>Adopciones Norte &copy; 2026</p>
  <p>
    <Icon scale="1" data={faPhone} />
    &nbsp;(55) 2896-5419
  </p>
  <p>Todos los derechos reservados</p>
</div>

<style>
  .footer {
    width: 100%;
    background-color: black;
    color: white;
    text-align: center;
    padding: 4vh 0%;
  }
</style>
